import React, { useState } from 'react';
import DaySvg from './shared/UI/daySvg';
import BedSvg from './shared/UI/bedSvg';
import BusSvg from './shared/UI/busSvg';
import BagSvg from './shared/UI/bagSvg';
import ButtonSpinner from './shared/UI/button-spinner';
import { pluralHelper } from '../helpers/stringutils';
import { itineraryListData } from '../helpers/itineraryHelper';
import { numProducts } from '../helpers/itemsHelper';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToggleCollapseExpand  } from '../actions/utils';
import SearchWidgetSimple from './shared/search/search-widget-simple';
import { MutateBooking } from '../actions/booking';
import { withApollo } from 'react-apollo'; 
import cookie from "js-cookie";
import { get } from '../helpers/objectHelper';


dayjs.extend(AdvancedFormat);

const BookingHighLights = (props) => {

    const [isExpand, setExpand] = useState(true);
    const [departureDate, SetDeparture] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitting, setSubmitting] = useState(false);


    const { itinerary, items, ToggleCollapseExpand, meta } = props;
    const _itineraryList = (itinerary === undefined) ? [] : itinerary;        
    const { stops } = itineraryListData(0, _itineraryList);
    const _numTrips = numProducts(items);
    const _days = meta !== undefined ? meta.days : "";
    const _accommodationNight = meta !== undefined ? meta.nights : "";

    const onContinue = async () => {

        setSubmitting(true);

        const { uuid, currency } = document.getElementById("ap-popular-itineraries").dataset;
        const token = cookie.get("ap.token");
        const itineraryPath = (process.env.NODE_ENV === 'production') ? `&p=${window.location.href.substring(window.location.href.lastIndexOf('/') + 1)}` : '&p=testing';
   
        const mutateResponse = await MutateBooking(props.client, uuid, currency, departureDate, true, true);
        if(Object.keys(mutateResponse.data.mutateBooking).length > 0 && !mutateResponse.data.mutateBooking.error){
            window.location.href =`${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${mutateResponse.data.mutateBooking.newBooking}&t=${token}&m=1${itineraryPath}`;
        }else{
            setSubmitting(false);
            setErrorMessage(get(['data', 'mutateBooking', 'message'], mutateResponse, "Unspecified error"));
        }

    }

    const renderListItem = (data) => {

        const _hasAccommodation = (data.accommodation === null || data.accommodation.reservations === null || data.nights === 0) ? false : true;
        const _accommodationData = {
             nights:_hasAccommodation ? data.accommodation.nights : "",
             type:_hasAccommodation ? data.accommodation.reservations[0].type.toLowerCase() : ""
         }
 
         switch(data.type){
             case "city":
             case "start":
             case "overnight":
                 return (
                     <>
                     <p className="f-size-16 regular">{data.to}</p>
                     <p>
                         {`${dayjs(data.date).format("D MMMM")} - ${dayjs(data.endDate).format("D MMMM")} `}
                         <span className="agent-portal-grey regular">
                             { _hasAccommodation ? `(${_accommodationData.nights} ${pluralHelper('night', _accommodationData.nights)} ${_accommodationData.type} room)` : "(no accommodation)" }
                         </span>
                     </p>
                     </>
                 )
             case "product":
                 return (
                     <>
                     <p className="f-size-16 regular">{data.name}</p>
                     <p>{`${data.productInfo.startCity.name} to ${data.productInfo.endCity.name}`}</p>
                     <p>
                         {`${dayjs(data.date).format("D MMMM")} - ${dayjs(data.endDate).format("D MMMM")} `}
                         <span className="agent-portal-grey regular">
                             ({data.nights} {pluralHelper('night', data.nights)})
                         </span>
                     </p>
                     </>
                 )
             case "extend":    
             case "gap":
                 return (
                    <p><span className="border-style">Itinerary break! Please make your own way</span></p>
                 )
             default: 
                return null;        
         }
     }

    document.body.addEventListener('CITY_START_DATE_CLICK', (e) => { SetDeparture(e.detail) });

    return (
        <div className="booking-hightlights">
    
          <div className="lg-flex clearfix icon-container">
            <div className="lg-flex col col-12 sm-col-8 px2 items-center icon-wrapper">
                <DaySvg clazz={"mr1"} /> <span className="bold mr2">{_days} days</span>
                <BedSvg clazz={"mr1"} /> <span className="bold mr2">{_accommodationNight} nights</span>
                <BusSvg clazz={"mr1"} /> <span className="bold mr2">{stops} stops</span>
                { _numTrips > 0 && <><BagSvg clazz={"mr1"} /> <span className="bold mr2 f-size-14">{_numTrips} trips</span></> }
            </div>
            <div className="lg-flex col col-12 sm-col-4 px2 items-center justify-end">
                <button className="rounded-svg-btn paxButton full-width-mobile" onClick={() => {
                    setExpand(!isExpand);
                    ToggleCollapseExpand(!isExpand);
                 }}>
                    {isExpand ? "Collapse" : "Expand"}
                    <svg xmlns="http://www.w3.org/2000/svg" height="9" width="16" className={`ml1 arrow ${isExpand ? 'active' : ''}`}>  
                        <path fill="#3D3D3D" fillRule="evenodd" d="M7.578 9.345L.233 2.06a.596.596 0 0 1 0-.844l.983-.983a.596.596 0 0 1 .844 0L8 6.114l5.94-5.88a.596.596 0 0 1 .844 0l.983.982a.596.596 0 0 1 0 .844L8.422 9.345a.596.596 0 0 1-.844 0z"/>
                    </svg>
                </button>
            </div> 
          </div>

        { isExpand && 
            <>
                <div className="clearfix">
                    <div className="col col-12 px2">
                        <hr className="mt2 mb2"/>
                    </div>
                </div>

                <div className="clearfix">
                    <div className="col col-12 px2">
                        <ul className="builder-list itinerary-list itinerary-list-modal">
                                { 
                                    _itineraryList.map((data, index) => {
                                        //conditional class value for product/city and extends
                                        const itineraryDataType = (index !== 0 && data.type === "start") ? 'gap-start' : data.type;
                                        const preGapType = ((data.type === "city" || data.type === "start" || data.type === "product") && _itineraryList[ index < _itineraryList.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                        const doubleGapType = (itineraryDataType === "gap-start" && _itineraryList[ index < _itineraryList.length -1  ? index + 1 : 0].type === "gap") ? 'pre-gap' : '';
                                        const productCityOrExtends = (data.type !== "extend") ? `builder-list-item builder-list-item-card planner-modal ${itineraryDataType} ${preGapType} ${doubleGapType} ${(_itineraryList.length === index + 1 )? 'last': ''} ` : `extend-list-item`;
                                        return <li key={index} className={`${productCityOrExtends}`}> { renderListItem(data) }</li> 
                                    })
                                }
                        </ul>     
                    </div>
                </div> 
            </>
        }


        <div className="clearfix">
            <div className={`col col-12 px2 mb2 ${!isExpand ? 'mt2' : ''}`}>
                <SearchWidgetSimple />
            </div>
        </div>      


          <div className="clearfix">
            <div className={`col col-12 px2 ${!isExpand ? 'mt2' : ''}`}>
                <button className="busabout--cta orange rounded-corner full-width" onClick={onContinue} disabled={departureDate === "" || isSubmitting}>
                    { !isSubmitting && <>Continue planning</> }  
                    { isSubmitting &&  <ButtonSpinner clazz={"white"} /> }  
                </button>

                {errorMessage !== "" && <p className={`info-box mt2 ${errorMessage !== "" ? 'block' : ''}`}>{errorMessage}</p>}
            </div>
          </div>  

        </div>
    )
}

const mapStateToProps = state => {
    return{
        itinerary:state.currentBooking.itinerary,
        items:state.currentBooking.items,
        meta:state.currentBooking.meta
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleCollapseExpand
    }, dispatch);
  }
  
export default withApollo(connect(mapStateToProps, mapDispatchToProps)(BookingHighLights));